document.addEventListener('DOMContentLoaded', function () {
  const mainImageWrapper = document.querySelector('.woocommerce-product-gallery__image--main');
  const mainImageContainer = mainImageWrapper?.querySelector('.woocommerce-product-gallery__image--item');
  const mainImage = mainImageContainer?.querySelector('img');
  const thumbnails = document.querySelectorAll('.woocommerce-product-gallery__image--thumbs .woocommerce-product-gallery__image--item img');

  // Crear el modal
  const modal = document.createElement('div');
  modal.id = 'image-modal';
  modal.innerHTML = '<img src="" alt="">';
  document.body.appendChild(modal);
  const modalImg = modal.querySelector('img');

  // Función para actualizar la imagen principal
  function updateMainImage(thumb) {
    const newSrc = thumb.src;
    const newAlt = thumb.alt || '';
    const newThumb = thumb.closest('.woocommerce-product-gallery__image--item')?.dataset.thumb || '';

    if (mainImage && newSrc) {
      mainImage.src = newSrc;
      mainImage.alt = newAlt;
      mainImageContainer.dataset.thumb = newThumb;
    }
  }

  // Eventos hover y click sobre thumbnails
  thumbnails.forEach(thumb => {
  //  thumb.addEventListener('mouseenter', () => updateMainImage(thumb));
    thumb.addEventListener('click', (e) => {
      e.preventDefault(); // Previene comportamiento inesperado si hay enlaces
      updateMainImage(thumb);
    });
  });

  // Click en imagen principal → abre modal
  mainImage?.addEventListener('click', () => {
    modalImg.src = mainImage.src;
    modalImg.alt = mainImage.alt;
    modal.classList.add('show');
  });

  // Cerrar modal haciendo click fuera de la imagen
  modal.addEventListener('click', e => {
    if (e.target === modal) {
      modal.classList.remove('show');
    }
  });
});
